ACC.skipLink = {

    _autoload: [
        'init',
    ],

    init() {
        const skipLink = document.querySelector('.skip-nav');
        if (skipLink) {
            return;
        }

        const body = document.querySelector('body');
        const link = document.createElement('a');

        link.classList.add('skip-nav');
        link.dataset.role = 'none';
        link.href = '#main-content';
        link.textContent = 'Skip to main content';

        body.prepend(link);
    },
};
